module.exports = __webpack_public_path__ + "static/media/73.fe884757.webp";